import 'assets/style/index.scss'
import Footer from 'components/Footer'
import Header from 'components/Header'
import { Footer as LaindingFooter } from 'components/Widgets/Landing'
import LoginModal from 'components/Widgets/LoginModal'
import React, { Suspense, useState, useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import { GlobalStyle } from './Global.style'
import {
  Container,
  Content,
  FooterContainer,
  HeaderContainer,
} from './Layout.style'
import { whiteOrange } from './theme'
import OrderModal from '../components/Widgets/OrderModal'
import Loader from 'components/Loader'

const Layout = props => {
  const { layoutType, excludeFooter } = props
  const [excludeHeader, setExcludeHeader] = useState(false)

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const id = queryParams.get('id')
    if (!id) {
      setExcludeHeader(true)
    } else {
      setExcludeHeader(false)
    }
  }, [])
  return (
    <ThemeProvider theme={whiteOrange}>
      <GlobalStyle />
      {layoutType !== 'landing' ? (
        <div className="app-main-container">
          <HeaderContainer>
            <OrderModal />
            {excludeHeader ? (
              <div className="container">
                <Header config={{}} />
              </div>
            ) : null}
          </HeaderContainer>
          <Content>
            {layoutType === 'withoutContainer' ? (
              <Suspense
                fallback={<Loader notFull visible={true} type="ThreeDots" />}
              >
                {props.children}
              </Suspense>
            ) : (
              <Container id="content-container">
                <Suspense
                  fallback={<Loader notFull visible={true} type="ThreeDots" />}
                >
                  {props.children}
                </Suspense>
              </Container>
            )}
          </Content>
          {excludeHeader ? (
            <FooterContainer>
              <Container>
                <Footer />
              </Container>
            </FooterContainer>
          ) : null}
          <LoginModal />
        </div>
      ) : (
        <Suspense fallback={<Loader notFull visible={true} type="ThreeDots" />}>
          {props.children}
          {!excludeFooter && <LaindingFooter />}
        </Suspense>
      )}
    </ThemeProvider>
  )
}

export default Layout
